<template>
  <span class="svg-icon-paper-plane">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.73543 15.1018C9.05543 19.0718 10.7254 19.9018 11.9054 19.9018C13.0854 19.9018 14.7554 19.0718 16.0854 15.0918L18.9154 6.6018C19.6254 4.4818 19.4154 2.7018 18.3254 1.6218C17.2354 0.5418 15.4654 0.3318 13.3454 1.0418L4.85543 3.8718C0.89543 5.2018 0.0654297 6.8818 0.0654297 8.0518C0.0654297 9.2318 0.89543 10.9018 4.85543 12.2218L7.01543 12.9418L7.73543 15.1018ZM1.55543 8.0518C1.55543 7.3318 2.54543 6.2318 5.32543 5.3018L13.8154 2.4618C15.3454 1.9518 16.6054 2.0318 17.2554 2.6818C17.9054 3.3318 17.9954 4.5918 17.4854 6.1318L14.6554 14.6218C13.7254 17.4018 12.6254 18.3918 11.9054 18.3918C11.1854 18.3918 10.0754 17.4018 9.15543 14.6218L8.40535 12.3716L11.9054 8.86179C12.1954 8.57179 12.1954 8.09179 11.9054 7.80179C11.6154 7.51179 11.1354 7.51179 10.8454 7.80179L7.26535 11.3918C7.25379 11.4033 7.2427 11.4152 7.23206 11.4273L5.32543 10.7918C2.54543 9.8718 1.55543 8.7718 1.55543 8.0518Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
